import React from "react";
import Warmup from "./Warmup";

// AppLoading is used by providers/routes that need a full-screen "still loading" state
// AFTER the initial Warmup has completed. We render the same Warmup component so the
// brand lockup, tips, progress bar, and animation are identical — no flicker between
// the index.html instant splash, Warmup, and AppLoading.
export default function AppLoading() {
  return <Warmup phase="loading" />;
}
